module.exports = __webpack_public_path__ + "static/banner-bg2-b865d38d766030d15b27588b42411375.jpg";